import { StyleRulesCallback } from '@material-ui/core/styles/withStyles';

const enumTranslateDialogStyle: StyleRulesCallback = () => {
  return {
    paperWidthMd: {
      width: '500px',
    },
  };
};

export default enumTranslateDialogStyle;
